import {instance} from "../lib/request";

function get(options) {
    return instance.get('/api/web/home/get',{
        params: options,
    });
}


export default {
    get
}
